import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthFormComponent } from './auth-form';

const routes: Routes = [
  { path: 'login', component: AuthFormComponent },
  { path: 'logout', component: AuthFormComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/auth/auth-routing.module.ts